import { useEffect, useState } from 'react';
import { EventBus, EVENTS } from '../../../shared/EventBus';

/**
 * The id of the map the player is on, from the sticky LEVEL_LOADED event
 * (replayed on subscribe, so a late mount still knows). For tome vibes on
 * surfaces outside the HUD root (target frame, social windows; lane BM).
 */
export function useCurrentZoneId(): string | null {
  const [zoneId, setZoneId] = useState<string | null>(null);
  useEffect(() => EventBus.getInstance().on(EVENTS.LEVEL_LOADED, (data: { id?: string }) => {
    if (data?.id) setZoneId(data.id);
  }), []);
  return zoneId;
}
